<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eAGLeZ/tc-custom/9781504011792.jpg?1704761351204" alt="This image is the cover for the book Serafina's Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Serafina's Stories
      </h1>
      <p class="bookDescription body article font2">
        <b>This innovative novel combines Spanish folktales with Native American legends to create a captivating Southwestern version of <i>The Arabian Nights.</i></b><br/><br/> Like Scheherezade, who ensured her survival by telling her royal husband stories, the title character in Rudolfo Anaya’s creative retelling of <i>The Arabian Nights </i>must entertain the recently widowed governor with legends of Nueva Mexicana, or she and her fellow captives will die.<br/><br/> With fresh snow covering the high peaks of Sangre de Cristo, a group of native dissidents prepare for revolt. In seventeenth-century Santa Fe, insurrection against a colony of the king of Spain is punishable by death. A Spaniard loyal to the governor names twelve conspirators. One of them is a young woman. Raised in a mission church, fifteen-year-old Serafina speaks excellent Spanish and knows many of her country’s traditional folktales. She and the governor strike a bargain: Each evening, she will tell him a <i>cuento</i>. If he likes it, he will release one prisoner the following day.<br/><br/> The twelve tales recounted here mirror the struggle of a divided country. They include the social and political symbolism behind “Beauty and the Beast” and retell “Cinderella” as “Miranda’s Gift.” Interspersed with these timeless <i>cuentos </i>is the story of Serafina herself, and that of a people battling to preserve a vanishing way of life under the long shadow of the Inquisition.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rudolfo Anaya
      </h2>
      
      <p class="authorDescription body article">Rudolfo Anaya is professor emeritus of English at the University of New Mexico. He has received numerous literary awards, including the Premio Quinto Sol and a National Medal of Arts. He is the author of the classic work&#160;<I>Bless Me, Ultima</I>, which was chosen for the National Endowment for the Arts&rsquo; Big Read. Anaya&rsquo;s other books for adults include&#160;<I>Tortuga</I>,&#160;<I>Heart of Aztlan</I>,<I>&#160;Alburquerque</I>,<I>&#160;Rio Grande Fall</I>,<I>&#160;Shaman Winter</I>,<I>&#160;Jemez Spring</I>,<I>&#160;Serafina&rsquo;s Stories</I>,<I>&#160;The Man Who Could Fly and Other Stories</I>,&#160;and&#160;<I>Rudolfo Anaya: The Essays.</I>&#160;His children&rsquo;s books include&#160;<I>Farolitos of Christmas</I>,<I>&#160;My Land Sings</I>,<I>&#160;Elegy on the Death of C&eacute;sar Ch&aacute;vez</I>,<I>&#160;Roadrunner&rsquo;s Dance</I>, and&#160;<I>The First Tortilla</I>.&#160;<I>Bless Me, Ultima</I>&#160;was adapted into a feature film in 2013. Anaya resides in Albuquerque, New Mexico.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8198bd04